<template>
  <div class="home space-y-6 flex-col mt-auto h-fit pt-20">
    <div class=" h-fit ">
      <img alt="Vue logo" src="../../assets/logo.png" class=" w-24 h-24 my-10  m-auto ">
      <div class=" flex flex-col space-y-6 mx-9">
        <router-link class="btn bg-green-600 shadow-black shadow-sm" to="/login">Login</router-link>
        <router-link class="btn bg-blue-600 shadow-black shadow-sm" to="/SignUp">Sign up</router-link>
        <!-- <router-link class="btn" to="/OpenBanks">Login as Guest</router-link> -->
      </div>
    </div>
    
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  }
}
</script>
